module.exports = __webpack_public_path__ + "static/media/l-md18.b97fa023.png";